module.exports = __webpack_public_path__ + "static/img/新征程.2a573e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/新征程.jpg
// module id = ypqx
// module chunks = 1